/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitAddEntityRequest } from './MonitAddEntityRequest';
import {
    MonitAddEntityRequestFromJSON,
    MonitAddEntityRequestFromJSONTyped,
    MonitAddEntityRequestToJSON,
} from './MonitAddEntityRequest';
import type { MonitRelationType } from './MonitRelationType';
import {
    MonitRelationTypeFromJSON,
    MonitRelationTypeFromJSONTyped,
    MonitRelationTypeToJSON,
} from './MonitRelationType';

/**
 * 
 * @export
 * @interface MonitAddOrUpdateEntityRequestRoot
 */
export interface MonitAddOrUpdateEntityRequestRoot {
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    monit_type?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    entity_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    data_sources?: Array<string>;
    /**
     * 
     * @type {MonitRelationType}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    relation?: MonitRelationType;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    keywords?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    related_domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    related_addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    number_of_employees?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    number_of_pii_records?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    company_revenue?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    country_code?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitAddOrUpdateEntityRequestRoot
     */
    entity_logo_url?: string;
}

/**
 * Check if a given object implements the MonitAddOrUpdateEntityRequestRoot interface.
 */
export function instanceOfMonitAddOrUpdateEntityRequestRoot(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitAddOrUpdateEntityRequestRootFromJSON(json: any): MonitAddOrUpdateEntityRequestRoot {
    return MonitAddOrUpdateEntityRequestRootFromJSONTyped(json, false);
}

export function MonitAddOrUpdateEntityRequestRootFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitAddOrUpdateEntityRequestRoot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'monit_type': !exists(json, 'monit_type') ? undefined : json['monit_type'],
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'data_sources': !exists(json, 'data_sources') ? undefined : json['data_sources'],
        'relation': !exists(json, 'relation') ? undefined : MonitRelationTypeFromJSON(json['relation']),
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'related_domains': !exists(json, 'related_domains') ? undefined : json['related_domains'],
        'related_addresses': !exists(json, 'related_addresses') ? undefined : json['related_addresses'],
        'industry': !exists(json, 'industry') ? undefined : json['industry'],
        'number_of_employees': !exists(json, 'number_of_employees') ? undefined : json['number_of_employees'],
        'number_of_pii_records': !exists(json, 'number_of_pii_records') ? undefined : json['number_of_pii_records'],
        'company_revenue': !exists(json, 'company_revenue') ? undefined : json['company_revenue'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'entity_logo_url': !exists(json, 'entity_logo_url') ? undefined : json['entity_logo_url'],
    };
}

export function MonitAddOrUpdateEntityRequestRootToJSON(value?: MonitAddOrUpdateEntityRequestRoot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_domain': value.entity_domain,
        'monit_type': value.monit_type,
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'data_sources': value.data_sources,
        'relation': MonitRelationTypeToJSON(value.relation),
        'domains': value.domains,
        'ip_addresses': value.ip_addresses,
        'keywords': value.keywords,
        'related_domains': value.related_domains,
        'related_addresses': value.related_addresses,
        'industry': value.industry,
        'number_of_employees': value.number_of_employees,
        'number_of_pii_records': value.number_of_pii_records,
        'company_revenue': value.company_revenue,
        'country_code': value.country_code,
        'currency': value.currency,
        'entity_logo_url': value.entity_logo_url,
    };
}

